import $ from 'jquery';
import 'rangeslider.js';
import inRange from 'lodash/inRange';
import initCalculator from './calculator-barchart';

const modal = document.querySelector('.js-calculator-modal');
const triggers = Array.from(document.querySelectorAll('.js-calculator-modal-trigger'));
const dismissers = Array.from(document.querySelectorAll('.js-calculator-modal-dismiss'));
const validationMessage = document.querySelector('[data-for=validationMessage]');

const income = document.querySelector('[data-for=currentSaving]');
if (income) {
    income.addEventListener('keyup', () => {
        income.value = income.value.replace(/,/gi, '').replace(/\d(?=(?:\d{3})+$)/g, '$&,');
    });
}


function errorMessage(message = 'Please fill in your age and deposit') {
    validationMessage.textContent = message;
}

function setCalculator(amount, age) {
    modal.querySelector('[data-for=futureYears]').textContent = age + 10;
    modal.querySelector('[data-for=initialDeposit]').value = amount;

    modal.classList.add('is-active');
    document.querySelector('body').classList.add('calculator-modal-active');
    initCalculator(modal, age);
}

function inputValidation(currentSaving, currentAge) {
    const age = Number(currentAge.value);
    const amount = Number(currentSaving.value.replace(/,/gi, ''));

    if (amount && age) {
        if (age < 18) {
            currentAge.parentNode.classList.add('is-invalid');
            errorMessage('You must be over the age of 18');
        } else if (age > 150) {
            currentAge.parentNode.classList.add('is-invalid');
            errorMessage('Please enter a valid age');
        } else if (amount < 10000) {
            currentSaving.parentNode.classList.add('is-invalid');
            errorMessage('The minimum initial deposit is $10,000');
            window.dataLayer.push({
                event: 'calculatorIneligible',
            });
        } else {

            let userFunds;
            let bracket;

            switch (true) {
            case inRange(amount, 0, 5000):
                userFunds = '$0-4,999';
                bracket = 1;
                break;
            case inRange(amount, 5000, 10000):
                userFunds = '$5,000-9,999';
                bracket = 2;
                break;
            case inRange(amount, 10000, 20000):
                userFunds = '$10,000-19,999';
                bracket = 3;
                break;
            case inRange(amount, 20000, 30000):
                userFunds = '$20,000-29,999';
                bracket = 4;
                break;
            case inRange(amount, 30000, 50000):
                userFunds = '$30,000-49,999';
                bracket = 5;
                break;
            case inRange(amount, 50000, 100000):
                userFunds = '$50,000-99,999';
                bracket = 6;
                break;
            default:
                userFunds = '$100,000+';
                bracket = 7;
                break;
            }

            const calculatorType = modal.querySelector('[name=calculatorType]').value;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'calculateReturns',
                userFunds,
                calculatorType,
            });

            window.fbq('track', 'ViewContent', {
                value: bracket,
                content_name: calculatorType === 'Investing Calculator' ? 'Investing' : 'Saving',
            });

            setCalculator(amount, age);
        }

    } else {
        currentAge.parentNode.classList.add('is-invalid');
        currentSaving.parentNode.classList.add('is-invalid');
        errorMessage();
    }
}

triggers.forEach((trigger) => {
    trigger.addEventListener('submit', (e) => {
        e.preventDefault();

        const currentSaving = trigger.querySelector('[data-for=currentSaving]');
        const currentAge = trigger.querySelector('[data-for=currentAge]');

        inputValidation(currentSaving, currentAge);
    });
});

dismissers.forEach((dismiss) => {
    dismiss.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('is-active');
        document.querySelector('body').classList.remove('calculator-modal-active');

        document.querySelector('.britechart').remove();

        const sliders = Array.from(document.querySelectorAll('input[type="range'));
        sliders.forEach((slider) => {
            $(slider).rangeslider('destroy');
        });
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/calculator-modal.js